export default __webpack_public_path__ + "media/images/icons/clock-regular-0d4adac451ddc8319353c9552500c05f.svg";